import { render, staticRenderFns } from "./VueCalendar.vue?vue&type=template&id=44207026&"
import script from "./VueCalendar.vue?vue&type=script&lang=js&"
export * from "./VueCalendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports